import { atom } from "recoil";

export const contactState = atom({
    key: "contactState",
    default: [],
});